// ======================================================================
// File Name       : contentDistribution
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import moment from 'moment';
import * as actionTypes from '../constants/ActionTypes';
import * as contentDistributionActionTypes from '../constants/actionTypes/contentDistribution';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../constants/index';

const initialState = {
  distributionServiceListInfo: {
    recordNum: 0,
    distributionServiceList: [],
  },
  redirectToDetail: false,
  redirectToList: false,
  deleteContentList: [],
  existContentList: [],
  firstContentList: [],
  isFirst: false,
  // using for offer list detail
  offerListDetail: {
    distributionContentList: [],
    contentRecordNum: 0,
    distributionCourseList: [],
    courseRecordNum: 0,
    distributionStatus: 0,
    serviceName: '',
  },

  enterpriseList: [],
  // using for diatribution list
  distributionOfferList: {
    existedContentListInfo: {
      byCd: {},
      allCds: [],
    },
    distributionServiceInfo: {},
    contentSearchResult: {},
    distributionContentList: [],

    existedCourseListInfo: {
      byCd: {},
      allCds: [],
    },
    courseSearchResult: {},
    distributionCourseList: [],
    isSaveDistributionSuccess: false,
  },
  contentDistributionUsage: {
    recordNum: 0,
    distributionServiceList: [],
    distributionUsageInfo: null,
  },
};

export default function contentDistribution(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CONTENT_DISTRIBUTION_SERVICE_SEARCH: {
      const { distributionServiceListInfo } = action;
      return { ...state, ...{ distributionServiceListInfo } };
    }
    case actionTypes.CONTENT_DISTRIBUTION_SERVICE_RECEIVE_ENRTERPRISES: {
      const { enterpriseList } = action;
      const enterpriseInfo = enterpriseList.reduce(
        (acc, cur) => {
          acc.byCd[cur.enterpriseCd] = cur;
          acc.allCds.push(cur.enterpriseCd);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );
      const distributionServiceInfo = state.distributionServiceListInfo;
      distributionServiceInfo.distributionServiceList.forEach((service) => {
        service.enterpriseName = '';
        if (enterpriseInfo.byCd[service.enterpriseCd]) {
          service.enterpriseName = enterpriseInfo.byCd[service.enterpriseCd].enterpriseName;
        }
      });
      return { ...state, ...{ distributionServiceListInfo: distributionServiceInfo } };
    }
    // for detail - content list
    case actionTypes.CONTENT_DISTRIBUTION_CONTENTS_LIST: {
      const { offerListDetail } = state;
      const { contentResult } = action;
      offerListDetail.distributionStatus = contentResult.distributionStatus;
      offerListDetail.distributionContentList = contentResult.distributionContentList;
      offerListDetail.serviceName = contentResult.serviceName;
      offerListDetail.csvfileUrl = contentResult.csvfileUrl;
      offerListDetail.recordContentNum = contentResult.recordNum;
      return { ...state, ...{ offerListDetail } };
    }
    // for detail - course list
    case actionTypes.CONTENT_DISTRIBUTION_COURSE_LIST: {
      const { offerListDetail } = state;
      const { courseResult } = action;
      offerListDetail.distributionStatus = courseResult.distributionStatus;
      offerListDetail.distributionCourseList = courseResult.distributionCourseList;
      offerListDetail.serviceName = courseResult.serviceName;
      offerListDetail.csvfileUrl = courseResult.csvfileUrl;
      offerListDetail.recordCourseNum = courseResult.recordNum;
      return { ...state, ...{ offerListDetail } };
    }

    // for register - get service name
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_SERVICE_NAME: {
      const { distributionOfferList } = state;
      distributionOfferList.distributionServiceInfo = action.data.distributionServiceInfo;
      distributionOfferList.existedContentListInfo = {
        byCd: {},
        allCds: [],
      };
      distributionOfferList.existedCourseListInfo = {
        byCd: {},
        allCds: [],
      };
      return { ...state, ...{ distributionOfferList } };
    }
    // for register/edit - dialog search content
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_GET_CONTENT_LIST: {
      const { distributionOfferList } = state;
      distributionOfferList.contentSearchResult = action.data;
      return { ...state, ...{ distributionOfferList } };
    }
    // update content distribution list
    case contentDistributionActionTypes.OFFER_LIST_UPDATE_CONTENT_LIST: {
      const { distributionOfferList } = state;
      distributionOfferList.distributionContentList = action.dataList;
      return { ...state, ...{ distributionOfferList } };
    }
    // for register/edit - dialog search course
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_GET_COURSE_LIST: {
      const { distributionOfferList } = state;
      distributionOfferList.courseSearchResult = action.data;
      return { ...state, ...{ distributionOfferList } };
    }
    // update course distribution list
    case contentDistributionActionTypes.OFFER_LIST_UPDATE_COURSE_LIST: {
      const { distributionOfferList } = state;
      distributionOfferList.distributionCourseList = action.dataList;
      return { ...state, ...{ distributionOfferList } };
    }
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_SAVE_SUCCESS: {
      const { distributionOfferList } = state;
      distributionOfferList.isSaveDistributionSuccess = true;
      return { ...state, ...{ distributionOfferList } };
    }
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_LOCAL_PAGING: {
      const { distributionOfferList } = state;
      distributionOfferList.startPosition = action.startPosition;
      return { ...state, ...{ distributionOfferList } };
    }
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_LOCAL_SORT: {
      const { distributionOfferList } = state;
      distributionOfferList.distributionContentList = action.data;
      return { ...state, ...{ distributionOfferList } };
    }
    case contentDistributionActionTypes.CONTENT_DISTRIBUTION_REGISTER_RESET: {
      const distributionOfferList = {
        existedContentListInfo: {
          byCd: {},
          allCds: [],
        },
        existedCourseListInfo: {
          byCd: {},
          allCds: [],
        },
        distributionServiceInfo: {},
        contentSearchResult: {},
        distributionContentList: [],
        distributionCourseList: [],
        isSaveDistributionSuccess: false,
      };
      return {
        ...state,
        distributionOfferList,
      };
    }
    case contentDistributionActionTypes.GET_CONTENT_DISTRIBUTION_OFFER_LIST: {
      const { distributionOfferList } = state;
      const { distributionServiceInfo } = distributionOfferList;
      const { serviceName, serviceCd, distributionStatus, distributionContentList } = action.data;

      distributionOfferList.distributionContentList = distributionContentList;
      distributionServiceInfo.serviceName = serviceName;
      distributionServiceInfo.distributionStatus = distributionStatus;
      distributionServiceInfo.serviceCd = serviceCd;

      distributionOfferList.existedContentListInfo = distributionContentList &&
      distributionContentList.length &&
      distributionContentList.reduce(
        (acc, cur) => {
          const { contentSecernId, contentType } = cur;
          const contentSecernIdMix = `${contentSecernId}_${contentType}`;
          acc.byCd[contentSecernIdMix] = cur;
          acc.allCds.push(contentSecernIdMix);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );
      return {
        ...state,
        distributionOfferList,
      };
    }
    case contentDistributionActionTypes.GET_CONTENT_DISTRIBUTION_COURSE_LIST: {
      const { distributionOfferList } = state;
      const { distributionServiceInfo } = distributionOfferList;
      const { serviceName, serviceCd, distributionStatus, distributionCourseList } = action.data;
      distributionOfferList.distributionCourseList = distributionCourseList;
      distributionServiceInfo.serviceName = serviceName;
      distributionServiceInfo.distributionStatus = distributionStatus;
      distributionServiceInfo.serviceCd = serviceCd;

      distributionOfferList.existedCourseListInfo = distributionCourseList &&
      distributionCourseList.length &&
      distributionCourseList.reduce(
        (acc, cur) => {
          acc.byCd[cur.courseSecernId] = cur;
          acc.allCds.push(cur.courseSecernId);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );

      return {
        ...state,
        distributionOfferList,
      };
    }
    case actionTypes.CONTENT_DISTRIBUTION_EDIT_CONTENT: {
      return {
        ...state,
        ...{ redirectToDetail: true },
      };
    }
    case actionTypes.RECEIVED_CONTENT_DISTRIBUTION_FILE_LIST: {
      const { recordNum, importResultList } = action;
      const distributionImportedFileList = { recordNum, importResultList };
      return {
        ...state,
        ...{ distributionImportedFileList },
      };
    }
    case actionTypes.IMPORT_CONTENT_DISTRIBUTION_LIST: {
      return {
        ...state,
        ...{ resultOK: true },
      };
    }
    case actionTypes.CONTENT_DISTRIBUTION_USAGE: {
      const { contentDistributionUsage } = action;
      return { ...state, ...{ contentDistributionUsage } };
    }
    case actionTypes.COURSE_DISTRIBUTION_USAGE: {
      const { courseDistributionUsage } = action;
      return { ...state, ...{ courseDistributionUsage } };
    }
    case actionTypes.CONTENT_DISTRIBUTION_SERVICE_DELETE_RESULT: {
      return {
        ...state,
        ...{ deleteSuccess: true },
      };
    }
    case actionTypes.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL_RESET: {
      const offerListDetail = {
        distributionContentList: [],
        contentRecordNum: 0,
        distributionCourseList: [],
        courseRecordNum: 0,
        distributionStatus: 0,
        serviceName: '',
      };
      return {
        ...state,
        offerListDetail,
        deleteSuccess: false,
        redirectToList: false,
      };
    }
    case actionTypes.REMOVE_ALL_DISTRIBUTION_COURSE_OR_CONTENT_FROM_LIST: {
      const { isContent } = action;
      const distributionOfferList = { ...state.distributionOfferList };
      if (isContent) {
        distributionOfferList.distributionContentList = [];
      } else {
        distributionOfferList.distributionCourseList = [];
      }
      return {
        ...state,
        distributionOfferList,
      };
    }
    default:
      return state;
  }
}
